module.exports = __webpack_public_path__ + "static/media/bootstrap.37b1d295.svg";